<template>
  <div>
    <el-transfer v-model="selected" filterable :titles="[$t('table.packageItems'),$t('table.packageItemsSelected')]" :props="{key:'id',label:'desc'}" :data="allItems" style="width:100%">
    </el-transfer>
    <el-button class="transfer-footer" slot="left-footer" size="small" @click="handleUpdate">更新</el-button>
  </div>
</template>

<script>

import { fetchPackageItemList } from '../api/package-item'
export default {
  data () {
    return {
      selected: [],
      allItems: []
    }
  },
  created () {
    fetchPackageItemList({limit: 0}).then((res) => {
      this.allItems = res.data.map((item) => { item.id = parseInt(item.id); return item })
    })
  },
  mounted () {
    this.selected = this.value
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    },
    handleUpdate () {
      fetchPackageItemList({limit: 0}).then((res) => {
        this.allItems = res.data.map((item) => { item.id = parseInt(item.id); return item })
      })
    }
  },
  watch: {
    selected (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.selected = val
    }
  }
}
</script>

<style>
  @media screen and (min-width: 1300px) {
    .el-transfer-panel {
      width: 35%;
    }
  }
  @media screen and (max-width: 1300px) {
    .el-transfer-panel {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/card/components/PackageItemSelect.vue